module.exports = __webpack_public_path__ + "static/parade-2020-house04-887f6f0443ea0cd1883955a28a53a851.jpg";